// @flow

import React from 'react';

import Avatar from 'app/common/components/Avatar';
import Popover from 'app/common/components/Popover';
import PopoverMessage from 'app/common/components/PopoverMessage';

type ZapOwnerProps = {
  avatarUrl: string,
  email?: string,
  isShowingPopover: boolean,
  name: string,
  onHover: boolean => void,
};

const ZapOwner = (props: ZapOwnerProps) => {
  const message = !props.isShowingPopover ? null : (
    <PopoverMessage>{props.name}</PopoverMessage>
  );
  return (
    <Popover kind="simple dark compact no-wrap" shouldAttach={true} tag="div">
      <Avatar
        name={props.name || props.email || 'Zap Owner'}
        onMouseEnter={() => props.onHover(true)}
        onMouseLeave={() => props.onHover(false)}
        url={props.avatarUrl}
      />
      {message}
    </Popover>
  );
};

export default ZapOwner;
